import { render } from "./activitesTickets.vue?vue&type=template&id=f79b9626"
import script from "./activitesTickets.vue?vue&type=script&lang=ts"
export * from "./activitesTickets.vue?vue&type=script&lang=ts"
script.render = render

export default script